//ORDER MATTERS for this Enum - Categories in apps module are ordered based on enum order
export var CategoryType;
(function (CategoryType) {
    CategoryType["Productivity"] = "Productivity";
    CategoryType["Utilities"] = "Utilities";
    CategoryType["Education"] = "Education";
    CategoryType["Communication"] = "Communication";
    CategoryType["ContentManagement"] = "ContentManagement";
    CategoryType["ProjectManagement"] = "ProjectManagement";
    CategoryType["DeveloperTools"] = "DeveloperTools";
    CategoryType["EmployeeExperience"] = "EmployeeExperience";
})(CategoryType || (CategoryType = {}));
//# sourceMappingURL=Category.js.map